<template>
  <footer class="footer">
    <div class="container">
      
      <div class="content has-text-centered">
        <button class="button is-primary is-large" style="margin-bottom:20px;" @click="reload">Problem loading? Click me to try again.</button>
        <p class="social" >
          <a :href="'mailto://admin@roblutken.co.uk'">
            <span class="icon">
              <i class="fa fa-envelope"></i>
            </span>
          </a>
          <a href="https://twitter.com/RobLutken93">
            <span class="icon">
              <i class="fa fa-twitter"></i>
            </span>
          </a>
        </p>
        <p><span class="icon"><i class="fa fa-code"></i></span> with <span class="icon"><i class="fa fa-heart"></i></span> by <a>Robert Lutken</a>.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

  data () {
    return this.$store.state.pkg
  },
  methods: {
    reload () {
      this.$router.go(this.$router.currentRoute)
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/mixins';

.footer {
  margin-left: 180px;
  
  @include mobile() {
    margin-left: 0;
  }
  
  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }

}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?41067548